import { createFileRoute, Outlet } from '@tanstack/react-router'
import { listDatasetsOptions, listProjectsOptions } from '~/api-client/gen/@tanstack/react-query.gen'

export const Route = createFileRoute('/studio')({
	loader: ({ context }) => {
		context.queryClient.prefetchQuery(listProjectsOptions())
		context.queryClient.prefetchQuery(listDatasetsOptions())
	},
	component: Outlet,
})
